import React from "react";

import {isRequiredQuestion, isValidValue} from "../../../../../utils";
import {FIELD_REQUIRED_MSG} from "../../../../../constants";
import SelectFormElementV2 from "../../formElement/SelectFormElementV2";

function isSelectQuestionValid(question, step, afterChange, service) {
  if(isRequiredQuestion(question)){
    const isValid = isValidValue(question.answer);
    question.error = isValid ? null : FIELD_REQUIRED_MSG;

    return isValid;
  }

  return true;
}

export const SelectQuestionMethods = {
  required: isRequiredQuestion,
  valid: isSelectQuestionValid
}

const SelectQuestion = props => {
  const {
    question,
    onAnswerChange,
    dataService,
  } = props;

  const label = question.question_text;
  const required = SelectQuestionMethods.required(question);
  let options = question.config.choices || [];

  options = options.map(o => {
    return {id: o.id, value: o.uid, label: o.text, info: o.info}
  });

  const handleChange = (value) => {
    question.error = null;  // clean error
    onAnswerChange(question.uid, value);
  };

  return (
    <SelectFormElementV2
      label={label}
      required={required || question.required_check}
      value={question.answer || ''}
      error={question.error}
      onChange={handleChange}
      options={options}
      custom_classes={question.custom_classes}
      disabled={question.disabled}
      tooltip={question.tooltip}
      newDesign={dataService && dataService.isNewDesign}
      addEmptyOption
    />
  );
};

export default SelectQuestion;